import { useMemo } from 'react';

import clsx from 'clsx';
import { useSlate, useSlateSelection } from 'slate-react';

import Tooltip from '@app/components/tooltip';

import { getIsMarkActive, getOnMouseDown } from '../utils/mark-utils';
import type { Action, Kind } from './types';
import style from './toolbar-button.module.scss';

type Props = {
  kind: Kind;
  icon: JSX.Element;
  label: JSX.Element;
  className?: string;
  action: Action;
};

export const ToolbarButton = ({ kind, icon, label, className, action }: Props) => {
  const editor = useSlate();
  const hasSlateSelection = Boolean(useSlateSelection());
  const isMarkActive = getIsMarkActive(editor, kind);

  const onMouseDown = useMemo(
    () => getOnMouseDown(editor, kind, action),
    [
      editor,
      kind,
      action,
    ],
  );

  return (
    <Tooltip
      hideContent={!hasSlateSelection}
      message={label}
      side="bottom"
      usePortal={false}
    >
      <button
        type="button"
        disabled={!hasSlateSelection}
        className={clsx(style.ToolbarButton, className, {
          [style.SlateSelection]: hasSlateSelection,
          [style.MarkActive]: isMarkActive,
        })}
        onMouseDown={onMouseDown}
      >
        {icon}
      </button>
    </Tooltip>
  );
};
